(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_43902b7"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('professional-product-nav')) {
    customElements.define(
      'professional-product-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();

          const options = {
            signal: this.controller.signal
          };

          const items = Array.from(
            this.querySelectorAll('.pn-item')
          );

          const canHover = window.matchMedia(
            '(hover: hover) and (pointer: fine)'
          );

          const close = (item) => {
            item.removeAttribute('data-open');
            item.querySelector('.pn-panel').hidden = true;
            item.querySelector('.pn-link').setAttribute(
              'aria-expanded',
              'false'
            );
          };

          const open = (item) => {
            items.forEach((other) => {
              if (other !== item) {
                close(other);
              }
            });

            item.setAttribute('data-open', '');
            item.querySelector('.pn-panel').hidden = false;
            item.querySelector('.pn-link').setAttribute(
              'aria-expanded',
              'true'
            );
          };

          items.forEach((item) => {
            const link = item.querySelector('.pn-link');

            let pointerType = '';
            let wasOpenBeforePointer = false;

            close(item);

            item.addEventListener(
              'pointerenter',
              (event) => {
                if (
                  canHover.matches &&
                  event.pointerType === 'mouse'
                ) {
                  open(item);
                }
              },
              options
            );

            item.addEventListener(
              'pointerleave',
              (event) => {
                if (
                  event.pointerType === 'mouse' &&
                  !item.contains(document.activeElement)
                ) {
                  close(item);
                }
              },
              options
            );

            link.addEventListener(
              'pointerdown',
              (event) => {
                pointerType = event.pointerType;
                wasOpenBeforePointer =
                  item.hasAttribute('data-open');
              },
              options
            );

            link.addEventListener(
              'pointercancel',
              () => {
                pointerType = '';
              },
              options
            );

            link.addEventListener(
              'keydown',
              () => {
                pointerType = '';
              },
              options
            );

            link.addEventListener(
              'focus',
              () => {
                open(item);
              },
              options
            );

            link.addEventListener(
              'click',
              (event) => {
                const touchActivation =
                  pointerType === 'touch' ||
                  pointerType === 'pen';

                pointerType = '';

                if (
                  event.ctrlKey ||
                  event.metaKey ||
                  event.shiftKey ||
                  event.altKey
                ) {
                  return;
                }

                if (touchActivation && !wasOpenBeforePointer) {
                  event.preventDefault();
                  open(item);
                }
              },
              options
            );

            item.addEventListener(
              'focusout',
              (event) => {
                if (!item.contains(event.relatedTarget)) {
                  close(item);
                }
              },
              options
            );
          });

          document.addEventListener(
            'pointerdown',
            (event) => {
              if (!this.contains(event.target)) {
                items.forEach(close);
              }
            },
            options
          );

          document.addEventListener(
            'keydown',
            (event) => {
              if (event.key !== 'Escape') {
                return;
              }

              const activeItem = items.find((item) => {
                return item.hasAttribute('data-open');
              });

              if (!activeItem) {
                return;
              }

              if (activeItem.contains(document.activeElement)) {
                activeItem.querySelector('.pn-link').focus();
              }

              close(activeItem);
            },
            options
          );
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
